import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

// define an enum if feature gate key is used anywhere else in the app
export enum FLEET_CARDS_FEATURE_FLAGS {
  FLEET_CARDS_SHOW_CARDS_TAB_SIDEBAR = 'fleetcard-show-cards-tab-sidebar',
  FLEET_CARDS_STICKY_PROMO_BANNER_ENABLED = 'fleet-cards-sticky-promo-banner-enabled',
  FLEET_CARDS_HTTP_PREVIEW_API_INTERCEPTOR_ENABLED = 'http-cards-preview-api-interceptor',
  FLEET_CARDS_BRIDGEHAUL_MOTIVE_CARD_APP = 'fleet-cards-bridgehaul-card-application',
  FLEET_CARDS_REQUEST_CASH_ADVANCE_ENABLED = 'fleetcard_request_cash_advance_feature_enabled',
  FLEET_CARDS_LIMIT_TXN_FRAUD_ENABLED = 'fleetcard-limit-txn-fraud-enabled',
  FLEET_CARDS_SIFT_ENABLED = 'fleet-cards-send-data-to-sift-enabled',
  FLEET_CARDS_CASEYS_ENABLED = 'fleet-cards-caseys-enabled',
  FLEET_CARDS_USER_TIME_ZONE_IN_IFTA_REDIRECT_ENABLED = 'fleet-cards-user-timezone-in-ifta-redirect-enabled',
  FLEET_CARDS_USE_DISCOUNT_DETAILS_ENABLED = 'fleet-cards-use-discount-details-enabled',
  FLEET_CARDS_SORT_BY_SEQUENCE_NUMBER_ENABLED = 'fleet-cards-sort-by-sequence-number-enabled',
  FLEET_CARDS_IFTA_MCC_CHECK_ON_TRANSACTIONS_ENABLED = 'fleet-cards-ifta-mcc-check-on-transactions-enabled',
  FLEET_CARDS_FLEET_MCC_CHECK_ON_TRANSACTION_ENABLED = 'fleet-cards-fleet-mcc-check-on-transaction-enabled',
  FLEET_CARDS_DEMO_MODE_ENABLED = 'fleet-cards-demo-mode-enabled',
  FLEET_CARDS_UPSELL_ROLES_AND_PERMISSIONS_ENABLED = 'fleet-cards-upsell-roles-and-permissions-enabled',
  FLEET_CARDS_ADMIN_EMAIL_PREFERENCES_ENABLED = 'fleetcard-admin-email-preferences-enabled',
  FLEET_CARDS_SEPARATE_HEADERS_ENABLED = 'fleet-cards-seperate-headers-enabled',
  FLEET_CARDS_SAVINGS_FINDER_P1_ENABLED = 'fleet-cards-savings-finder-p-1-enabled',
  FLEET_CARDS_SAVINGS_FINDER_P2_ENABLED = 'fleet-cards-savings-finder-p-2-enabled',
  FLEET_CARDS_SAVINGS_FINDER_P3_ENABLED = 'fleet-cards-savings-finder-p-3-enabled',
  FLEET_CARDS_BULK_API_CARD_HOLDERS_ENABLED = 'fleet-cards-bulk-api-card-holders-enabled',
  FLEET_CARDS_FUEL_THEFT_LOCATION_FLEET_VIEW_ENABLED = 'fleet-cards-fuel-theft-location-fleetview-enabled',
  FLEET_CARDS_SPEND_SUMMARY_REPORT_DEMO_ENABLED = 'fleet-cards-spend-summary-report-demo-enabled',
  FLEET_CARDS_REMOVE_5_CENTS_OFF_EXPERIMENT_ENABLED = 'fleet-cards-remove-5-cents-off-experiment-enabled',
  FLEET_CARDS_CONTEXTUAL_UPSELL_ENABLED = 'fleet-cards-contextual-upsell-enabled',
  FLEET_CARDS_CARD_APPLICATION_INDUSTRY_FIELD_ENABLED = 'fleet-card-card-application-industry-field-enabled',
  FLEET_CARDS_ADMIN_VERSION_2_ENABLED = 'fleetcards-admin-version-2-enabled',
  FLEET_CARDS_REQUEST_FOR_CARDS_ENABLED = 'fleetcard_fm_request_for_cards_enabled',
  FLEET_CARDS_CARD_APPLICATION_IMPROVEMENT_ENABLED = 'fleet-cards-card-application-improvement-enabled',
  FLEET_CARDS_TRANSACTION_DATE_FILTER_ENABLED = 'fleet-cards-transaction_date_filter_enabled',
  FLEET_CARDS_MANUAL_CREDIT_ENABLED = 'fleet-card-manual-provisional-credit-fe-enabled',
  FLEET_CARDS_ACTIVATION_LANDING_PAGE_EXPERIMENT_ENABLED = 'fleet-cards-activation-landing-page-exp-enabled',
  FLEET_CARDS_SWEEPSTAKES_PROMO_ENABLED = 'fleet-cards-sweepstakes-promo-enabled',
  FLEET_CARDS_ACTIVATION_REMINDER_POPOVER_ENABLED = 'fleet-cards-activation-reminder-popover-enabled',
  FLEET_CARDS_PLAID_DEAUTH_DEFERRED_CREDIT_ENABLED = 'fleetcard-plaid-deauth-deferred-credit-enabled',
  FLEET_CARDS_MICRODEPOSIT_DEFERRED_CREDIT_ENABLED = 'fleetcard-microdeposit-deferred-credit-enabled',
  FLEET_CARDS_INACTIVE_ACCOUNT_CANCELLATION_ENABLED = 'fleet-cards-inactive-account-cancellation',
  FLEET_CARDS_MISSED_SAVINGS_WILD_CARD_SEARCH_ENABLED = 'missed_savings_wild_card_search_enabled',
  FLEET_CARDS_MERCHANT_RESTRICTION_ENABLED = 'fleet-cards-merchant-restriction-enabled',
  FLEET_CARDS_MERCHANT_RESTRICTION_V2_ENABLED = 'fleet-cards-merchant-restriction-v2-enabled',
  FLEET_CARDS_PHOENIX_FILTERS_ENABLED = 'fleet-cards-phoenix-filters-enabled',
  FLEET_CARDS_VEHICLE_CARD_SECURITY_TOGGLE_ENABLED = 'fleet-card-vehicle-card-security-toggle-enabled',
  FLEET_CARDS_ONBOARDING_WIZARD_ENABLED = 'fleet-cards-onboarding-wizard-enabled',
  FLEET_CARDS_VALUE_PROPS_LANDING_PAGE_ENABLED = 'fleet-cards-value-props-landing-page-enabled',
  FLEET_CARD_CAPTURE_POST_TRANSACTION_METADATA = 'fleetcard-post-txn-metadata-enabled',
  FLEET_CARDS_SKIP_CREATE_CCMD_ON_GET = 'fleet-card-skip-ccmd-create-on-get',
  FLEET_CARDS_FLEET_BUNDLE_ENABLED = 'fleet-cards-fleet-bundle-enabled',
  FLEET_CARDS_NEW_STATUS_LIST_ENABLED = 'fleet-card-new-status-list-enabled',
  FLEET_CARDS_VIRTUAL_ACCOUNT_ENABLED = 'fleet-cards-virtual-account-enabled',
  FLEET_CARDS_FLEET_BUNDLE_UPDATE_CREDIT_CARD = 'fleet-cards-fleet-bundle-update-credit-card',
  FLEET_CARDS_DECLINED_TRANSACTION_AVAILABLE_LIMIT = 'fleet-cards-declined-transaction-available-limit',
  FLEET_CARDS_REMOVE_BUSINESS_OWNERS_REQUIRED_CHECK_ENABLED = 'fleet-cards-remove-bo-required-check-enabled',
  FLEET_CARDS_DEACTIVATED_ENTITY_SEARCH_ENABLED = 'fleet-card-deactivated-entity-search-enabled',
  FLEET_CARDS_FUEL_TYPE_MISMATCH_ENABLED = 'fleet-card-fuel-type-mismatch-enabled',
  FLEET_CARDS_MISSED_SAVINGS_WORKFLOW_ENABLED = 'fleet-cards-missed-saving-workflow',
  FLEET_CARDS_MISSED_SAVINGS_MERCHANTS_ENABLED = 'fleet-cards-missed-savings-merchants',
  FLEET_CARDS_MOVE_TO_NEW_THEFT_DETECTION_FLOW_ENABLED = 'fleetcards-move-to-new-theft-detection-flow',
  FLEET_CARDS_FUEL_LEVEL_MISMATCH_ENABLED = 'fleet-card-fuel-tank-level-mismatch-enabled',
  FLEET_CARDS_FLEET_BUNDLE_ENABLED_ZOURA_ENABLED = 'fleet-cards-fleet-bundle-zuora-enabled',
  FLEET_CARDS_TXN_SOFT_DECLINED_ENABLED = 'fleetcard-txn-soft-declined-enabled-frontend',
  FLEET_CARDS_VEHICLE_PROXIMITY_BASED_DECLINES_ENABLED = 'fleetcard-vehicle-proximity-based-declines-enabled',
  FLEET_CARDS_SHOW_FUEL_PURCHASE_DATA_IN_CARD_APPLICATION = 'fleetcard-show-fuel-purchase-data-in-card-app',
  FLEET_CARDS_CARDS_REASSIGNMENT_ENABLED = 'fleetcard-card-reassignment-enabled',
  FLEET_CARDS_ADD_REASON_FOR_ORDER_FIELD_ENABLED = 'fleetcard_add_reason_for_order_field',
  FLEET_CARDS_TCV_ACV_REWARDS_ENABLED = 'fleetcard-fe-tcv-acv-rewards-enabled',
  FLEET_CARDS_GET_TRANSACTION_COUNT_FROM_COMPANY_API = 'fleetcard-get-transaction-count-from-company-api',
  FLEET_CARDS_TOP_SPENDERS_LITE_API_ENABLED = 'fleetcard-top-spenders-lite-api',
  FLEET_CARDS_BULK_EDIT_SECURITY_SETTINGS_ENABLED = 'fleet-cards-bulk-edit-security-settings',
  FLEET_CARDS_MCC_DESCRIPTION_ENABLED = 'fleet-cards-mcc-description-enabled',
  FLEET_CARDS_INDIVIDUAL_EDIT_SECURITY_SETTINGS_ENABLED = 'fleet-cards-individual-edit-security-settings',
  FLEET_CARDS_FUEL_TYPE_MISMATCH_FLAG_ENABLED = 'fleet-card-fuel-type-mismatch-flag-enabled',
  FLEET_CARDS_APPLICATION_NUDGE_EXPERIMENT_ENABLED = 'fleet-card-application-nudge-experiment-enabled',
  FLEET_CARDS_AUTO_DECLINE_TRANSACTION_M1_FUEL_LEVEL_ABOVE_X_ENABLED = 'fleet-cards-auto-decline-fuel-above-x-m1-fuel-level-settings-above-x',
  FLEET_CARDS_AUTO_DECLINE_TRANSACTION_M2_PERMANENT_CARD_OVERRIDES_ENABLED = 'fleet-cards-auto-decline-fuel-above-x-m2-permanent-card-overrides',
  FLEET_CARDS_BILLING_CYCLE_OPTION_IN_SCHEDULE_REPORT_ENABLED = 'fleetcard-billing-cycle-option-in-schedule-report-enabled',
  FLEET_CARDS_PAYMENT_WIDGET_CHANGES_ENABLED = 'fleet-cards-payment-widget-changes',
  FLEET_CARDS_FLEET_BUNDLE_EXPERIMENT_ENABLED = 'fleet-card-fleet-bundle-experiment-enabled',
  FLEET_CARDS_SETTINGS_PAGE_SPEND_PROFILE_PAGINATION_ENABLED = 'fleet-cards-settings-page-spend-profile-pagination-enabled',
  FLEET_CARDS_GRANULAR_SPEND_CONTROL_ENABLED = 'fleetcard-granular-spend-control-enabled',
  FLEET_CARDS_APPLICATION_EXPRESS_OPTION_ENABLED = 'fleet-cards-application-expedite-shipping-enabled',
  FLEET_CARDS_VLM_SURFACE_LAST_KNOWN_LOCATION_ENABLED = 'fleet-cards-vlm-surface-last-known-location',
  FLEET_CARDS_OVERVIEW_CHANGES_ENABLED = 'fleet-card-account-overview-changes-enabled',
  FLEET_CARDS_MISSED_SAVINGS_REFINEMENT_CHANGES = 'fleet-cards-missed-savings-refinement-changes',
  FLEET_CARDS_MISSING_L3_DATA_SUGGESTION = 'fleet-cards-missing-l3-data-suggestion',
  FLEET_CARDS_NUDGE_UPSELLS_PHASE2_ENABLED = 'fleet-cards-nudge-upsells-phase2-enabled',
  FLEET_CARDS_AUTO_DECLINE_ENHANCEMENT_FLAG_ENABLED = 'fleetcard-auto-decline-enhancement-flag',
  FLEET_CARDS_INCLUDE_TRANSACTION_FLEET_VIEW_ZOOM_ENABLED = 'fleet-cards-include-transaction-fleet-view-zoom-enabled',
  FLEET_CARDS_DEF_AND_REEFER_FUEL_RECATEGORIZATION_ENABLED = 'fleet-cards-def-and-reefer-fuel-recategorization-enabled',
  FLEET_CARDS_BONUS_REBATES_ENABLED = 'fleet-cards-bonus-rebates-enabled',
  FLEET_CARDS_BONUS_REBATES_OVERVIEW_SIDEBAR_ENABLED = 'fleet-cards-bonus-rebates-overview-sidebar-enabled',
  FLEET_CARDS_DEPRECATE_FLEET_VIEW_POPOVER = 'fleet-cards-deprecate-fleet-view-popover',
  FLEET_CARDS_TEMPORARY_OVERRIDES_FOR_SPEND_AND_SECURITY_CONTROLS = 'fleet-cards-temporary-overrides-for-spend-and-security-controls',
  FLEET_CARDS_BENEFITS_ESTIMATED_SAVINGS_BANNER_ENABLED = 'fleet-cards-benefits-estimated-savings-banner-enabled',
  FLEET_CARDS_CARD_INFO_V2_API_ENABLED = 'fleetcard-card-info-v2-api-enabled',
  FLEET_CARDS_GIR_INTEGRATION_FE_ENABLED = 'fleet-cards-gir-integration-fe-enabled',
  FLEET_CARDS_RELAY_PAYMENT_INTEGRATION_FE_ENABLED = 'fleet-cards-relay-payment-integration-fe-enabled',
  FLEET_CARDS_TOS_ENABLED = 'fleetcard-tos-enabled',
  FLEET_CARDS_ENABLE_MORE_TRANSACTION_CUSTOM_FIELDS_ENABLED = 'fleet-cards-enable-more-transaction-custom-fields-enabled',
  FLEET_CARDS_PROMO_OFFERS_ENABLED = 'fleet-cards-promo-offers-enabled',
  FLEET_CARDS_BENEFITS_PAGE_REFACTOR = 'fleet-cards-benefits-page-refactor',
  FLEET_CARDS_BULK_FUEL_AT_BOOSTER_ENABLED = 'fleet-cards-bulk-fuel-at-booster-enabled',
  FLEET_CARDS_SHOW_TOOLTIP_FOR_MCLEOD_ENABLED = 'fleet-cards-show-tooltip-for-mcleod-enabled',
  FLEET_CARDS_UPSELLS_LEAD_GENERATION_FOR_SAVINGS_ESTIMATE_1_29_ENABLED = 'fleet-cards-upsells-apply-now-lead-gen-savings-estimate-1-29-enabled',
  FLEET_CARDS_FLEET_USER_CARDS_ENABLED = 'fleetcard-fleet-user-cards-enabled',
  FLEET_CARDS_OVERRIDE_SUPPORT_ENABLED = 'fleet-user-card-override-support-enabled',
  FLEET_CARDS_CARD_ORDER_IMPROVEMENTS_ENABLED = 'fleet-cards-card-order-improvements-enabled',
  FLEET_CARD_CARD_ORDER_PUBLIC_APP_ENABLED = 'fleet-card-card-order-public-app-enabled',
  FLEET_CARDS_CAPTURE_ASSET_INFO_ON_TRANSACTIONS = 'fleetcard-asset-info-in-txn-m1',
  FLEET_CARDS_EDIT_CATEGORY_ENHANCEMENT_ENABLED = 'fleetcard-edit-categories-enhancement-enabled',
  FLEET_CARDS_NEW_CARD_ACTIVATION_FLOW_ENABLED = 'fleet-cards-new-card-activation-flow-enabled',
  FLEET_CARDS_NO_FRAUD_GUARANTEE_INSIGHTS_AND_BRANDING = 'fleet-cards-no-fraud-guarantee-insights-and-branding',
  FLEET_CARDS_SOFT_DECLINE_VSLM_AND_FUEL_ENABLED = 'fleetcard-soft-decline-vslm-and-fuel-enabled',
  FLEET_CARDS_SAAS_FEE_PUBLIC_APP_ENABLED = 'fleet-cards-saas-fees-public-app-enabled',
  FLEET_CARDS_SPEND_SUMMARY_REPORT_UPDATES_ENABLED = 'fleet-cards-spend-summary-report-updates-enabled',
  FLEET_CARDS_TRANSACTION_DETAILS_DRAWER_V3_ENABLED = 'fleet-cards-transaction-details-drawer-v3-enabled',
  FLEET_CARDS_2FA_VERIFICATION_FRONTEND_ENABLED = 'fleetcard-2fa-verification-frontend-enabled',
  FLEET_CARDS_APPLICATION_STATUS_STEPPER_ENABLED = 'fleetcard-application-status-stepper-enabled',
  FLEET_CARDS_MOTIVE_CARD_POLICY_PHASE_ONE_ENABLED = 'fleetcard-motive-card-policy-phase-one-enabled',
  FLEET_CARDS_SURFACING_ROI_ENABLED = 'fleet-cards-surfacing-roi-enabled',
  CARD_APPLICATION_CARD_DELIVERY_ADDRESS_ENABLED = 'card-application-card-delivery-address-enabled',
  FLEET_CARDS_SAVINGS_CALCULATOR_FE_ENABLED = "fleetcard-savings-calculator-fe-enabled",
  FLEET_CARDS_FEDERAL_FUEL_TAX_ENABLED = "fleet-cards-federal-fuel-tax-enabled",
  FLEET_CARDS_ADDITIONAL_TRANSACTION_CATEGOEIES_FE_ENABLED = "fleet-cards-additional-transaction-categories-fe-enabled",
  FLEET_CARD_BENEFITS_CTA_REFACTOR = 'fleet-card-benefits-cta-refactor',
}

// Statsig Experiments
export enum FLEET_CARDS_EXPERIMENTS {
  FLEET_CARDS_AB_TEST_ON_BENEFITS_PAGE = 'ab_test_on_cards_benefits_page',
  FLEET_CARDS_AB_TEST_ON_REMOVING_5_CENTS_OFF = 'ab_test_on_removing_5_cents_off',
  FLEET_CARDS_AB_TEST_ON_CONTEXTUAL_UPSELL_FUEL_OVERVIEW_PAGE = 'contextual_upsell_fuel_overview_page',
  FLEET_CARDS_AB_TEST_ON_CONTEXTUAL_UPSELL_FUEL_PURCHASE_PAGE = 'contextual_upsell_fuel_purchase_page',
  FLEET_CARDS_AB_TEST_ON_CONTEXTUAL_UPSELL_FUEL_RECEIPT_UPLOAD_PAGE = 'contextual_upsell_fuel_receipt_upload_page',
  FLEET_CARDS_ACTIVATION_LANDING_PAGE = 'activation_landing_page',
  FLEET_CARDS_SHOW_FUEL_PURCHASE_DATA_IN_CARD_APPLICATION = 'show_fuel_purchase_data_in_card_application',
  FLEET_CARDS_APPLICATION_NUDGE = 'fleetcard-application-nudge',
  FLEET_CARDS_EXPANSIONS_UPSELLS_STICKY_BANNER = 'expansion-upsells-sticky-banner',
}

@Injectable({ providedIn: 'root' })
export class FleetCardsFeatureFlagService {
  constructor(private statsigService: StatsigService) { }

  public isFleetCardShowCardsTabSidebarEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SHOW_CARDS_TAB_SIDEBAR);
  }

  public isBenefitsPageRefactorEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BENEFITS_PAGE_REFACTOR);
  }

  public isStickyPromoBannerEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_STICKY_PROMO_BANNER_ENABLED);
  }

  public isFleetCardsHttpPreviewApiInterceptorEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_HTTP_PREVIEW_API_INTERCEPTOR_ENABLED);
  }

  public isFleetCardsBridgehaulAppEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BRIDGEHAUL_MOTIVE_CARD_APP);
  }

  public isFleetCardsRequestCashAdvanceEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_REQUEST_CASH_ADVANCE_ENABLED);
  }

  public isFleetCardsLimitTxnFraudEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_LIMIT_TXN_FRAUD_ENABLED);
  }

  public isFleetCardsSiftEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SIFT_ENABLED);
  }

  public isFleetCardsInactiveAccCancellationEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_INACTIVE_ACCOUNT_CANCELLATION_ENABLED);
  }

  public isFleetCardsMissedSavingWildCardEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MISSED_SAVINGS_WILD_CARD_SEARCH_ENABLED);
  }

  public isFleetCardsPlaidDeauthDeferredCreditEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_PLAID_DEAUTH_DEFERRED_CREDIT_ENABLED);
  }

  public isFleetCardsMicrodepositDeferredCreditEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MICRODEPOSIT_DEFERRED_CREDIT_ENABLED);
  }

  public isFleetCardsCapturePostTransactionMetadata(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARD_CAPTURE_POST_TRANSACTION_METADATA);
  }

  public isFleetCardsAdminVersion2Enabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ADMIN_VERSION_2_ENABLED);
  }

  public isFleetCardsRequestForCardsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_REQUEST_FOR_CARDS_ENABLED);
  }

  public isUserTimeZoneInIFTARedirectEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_USER_TIME_ZONE_IN_IFTA_REDIRECT_ENABLED);
  }

  public isCaseysEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CASEYS_ENABLED);
  }

  public isUseDiscountDetailsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_USE_DISCOUNT_DETAILS_ENABLED);
  }

  public isSortBySequenceNumberEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SORT_BY_SEQUENCE_NUMBER_ENABLED);
  }

  public isFleetCardsUpsellRolesAndPermissionsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_UPSELL_ROLES_AND_PERMISSIONS_ENABLED);
  }

  public isIFTAMCCCheckOnTransactionsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_IFTA_MCC_CHECK_ON_TRANSACTIONS_ENABLED);
  }

  public isFleetMCCCheckOnTransactionsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FLEET_MCC_CHECK_ON_TRANSACTION_ENABLED);
  }

  public isEmailPreferencesEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ADMIN_EMAIL_PREFERENCES_ENABLED);
  }

  public isFleetCardsSeparateHeaderEnabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SEPARATE_HEADERS_ENABLED);
  }

  public isCardsSavingsFinderP1Enabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SAVINGS_FINDER_P1_ENABLED);
  }

  public isCardsSavingsFinderP2Enabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SAVINGS_FINDER_P2_ENABLED);
  }

  public isCardsSavingsFinderP3Enabled(): boolean {
    return this.statsigService
      .evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SAVINGS_FINDER_P3_ENABLED);
  }

  public isCardBulkApiCardHoldersEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BULK_API_CARD_HOLDERS_ENABLED);
  }

  public isFuelTheftLocationFleetViewEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FUEL_THEFT_LOCATION_FLEET_VIEW_ENABLED);
  }

  public isSpendSummaryReportDemoEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SPEND_SUMMARY_REPORT_DEMO_ENABLED);
  }

  public isCardsRemove5CentsOffExperimentEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_REMOVE_5_CENTS_OFF_EXPERIMENT_ENABLED);
  }

  public isCardsContextualUpsellEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CONTEXTUAL_UPSELL_ENABLED);
  }

  public isCardApplicationIndustryTypeFieldEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CARD_APPLICATION_INDUSTRY_FIELD_ENABLED);
  }

  public isCardApplicationImprovementEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CARD_APPLICATION_IMPROVEMENT_ENABLED);
  }

  public isTransactionDateFilterEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_TRANSACTION_DATE_FILTER_ENABLED);
  }

  public isCardsManualCreditEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MANUAL_CREDIT_ENABLED);
  }

  public isCardsActivationLandingPageExperimentEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ACTIVATION_LANDING_PAGE_EXPERIMENT_ENABLED);
  }

  public isCardsSweepstakesPromoEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SWEEPSTAKES_PROMO_ENABLED);
  }
  public isCardsActivationReminderEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ACTIVATION_REMINDER_POPOVER_ENABLED);
  }

  public isCardsPhoenixFiltersEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_PHOENIX_FILTERS_ENABLED);
  }

  public isCardsMerchantBasedRestrictionEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MERCHANT_RESTRICTION_ENABLED);
  }

  public isCardsMerchantBasedRestrictionV2Enabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MERCHANT_RESTRICTION_V2_ENABLED);
  }

  public isVehicleCardSecurityToggleEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_VEHICLE_CARD_SECURITY_TOGGLE_ENABLED);
  }

  public isCardsOnboardingWizardEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ONBOARDING_WIZARD_ENABLED);
  }

  public isValuePropsLandingPageEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_VALUE_PROPS_LANDING_PAGE_ENABLED);
  }

  public isCreateCCMDOnGetDisabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SKIP_CREATE_CCMD_ON_GET);
  }

  public isFleetCardsFleetBundleEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FLEET_BUNDLE_ENABLED)
      || this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FLEET_BUNDLE_ENABLED_ZOURA_ENABLED);
  }

  public isNewStatusListEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_NEW_STATUS_LIST_ENABLED);
  }

  public isVirtualAccountEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_VIRTUAL_ACCOUNT_ENABLED);
  }

  public isFleetCardsFleetBundleUpdateCreditCardEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FLEET_BUNDLE_UPDATE_CREDIT_CARD);
  }

  public isFleetCardsDeclinedTransactionAvailableLimitEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_DECLINED_TRANSACTION_AVAILABLE_LIMIT);
  }

  public isCardApplicationRemoveBusinessOwnersRequiredCheckEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_REMOVE_BUSINESS_OWNERS_REQUIRED_CHECK_ENABLED);
  }

  public isFleetCardsDeactivatedEntitySearchEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_DEACTIVATED_ENTITY_SEARCH_ENABLED);
  }

  public isFleetCardsFuelTypeMismatchEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FUEL_TYPE_MISMATCH_ENABLED);
  }

  public isFleetCardsMissedSavingEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MISSED_SAVINGS_WORKFLOW_ENABLED);
  }

  public isFleetCardsMissedSavingMerchantsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MISSED_SAVINGS_MERCHANTS_ENABLED);
  }

  public isFleetCardsMoveToNewTheftDetectionFlowEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MOVE_TO_NEW_THEFT_DETECTION_FLOW_ENABLED);
  }

  public isFleetCardsFuelAndSpendMismatchEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FUEL_LEVEL_MISMATCH_ENABLED);
  }

  public isFleetCardsTxnSoftDeclinedEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_TXN_SOFT_DECLINED_ENABLED);
  }

  public isFleetCardsVehicleProximityBasedDeclinesEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_VEHICLE_PROXIMITY_BASED_DECLINES_ENABLED);
  }

  public isFleetCardShowFuelPurchaseDataInCardApplicationEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SHOW_FUEL_PURCHASE_DATA_IN_CARD_APPLICATION);
  }

  public isFleetCardsReassignmentEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CARDS_REASSIGNMENT_ENABLED);
  }

  public isFleetCardShowReasonForOrderField(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ADD_REASON_FOR_ORDER_FIELD_ENABLED);
  }

  public isFleetCardTCVACVRewardsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_TCV_ACV_REWARDS_ENABLED);
  }

  public isFleetCardGetTransactionCountFromCompanyAPIEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_GET_TRANSACTION_COUNT_FROM_COMPANY_API);
  }

  public isFleetCardTopSpendersLiteApiEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_TOP_SPENDERS_LITE_API_ENABLED);
  }

  public isFleetCardsMccDescriptionEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MCC_DESCRIPTION_ENABLED);
  }

  public isFleetCardsIndividualEditSecuritySettingsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_INDIVIDUAL_EDIT_SECURITY_SETTINGS_ENABLED);
  }

  public isFleetCardsBulkEditSecuritySettingsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BULK_EDIT_SECURITY_SETTINGS_ENABLED);
  }

  public isFleetCardsFuelTypeMismatchFlagEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FUEL_TYPE_MISMATCH_FLAG_ENABLED);
  }

  public isFleetCardsApplicationNudgeExperimentEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_APPLICATION_NUDGE_EXPERIMENT_ENABLED);
  }

  public isFleetCardsFleetBundleExperimentEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FLEET_BUNDLE_EXPERIMENT_ENABLED);
  }

  public isFleetCardsSettingsPageSpendProfilePaginationEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SETTINGS_PAGE_SPEND_PROFILE_PAGINATION_ENABLED);
  }

  public isFleetCardsGranularSpendControlEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_GRANULAR_SPEND_CONTROL_ENABLED);
  }

  public isFleetCardsBillingCycleOptionInScheduleReportEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BILLING_CYCLE_OPTION_IN_SCHEDULE_REPORT_ENABLED,
    );
  }

  public isFleetCardsLeadGenForSE1to29Enabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_UPSELLS_LEAD_GENERATION_FOR_SAVINGS_ESTIMATE_1_29_ENABLED,
    );
  }

  public isFleetCardsCardOrderImprovementsEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CARD_ORDER_IMPROVEMENTS_ENABLED,
    );
  }

  public isFleetCardsCardOrderPublicAppEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARD_CARD_ORDER_PUBLIC_APP_ENABLED,
    );
  }

  public isFleetCards2FAVerificationEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_2FA_VERIFICATION_FRONTEND_ENABLED,
    );
  }

  public isFleetCardsApplicationStatusStepperEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_APPLICATION_STATUS_STEPPER_ENABLED,
    );
  }

  public isFleetCardsSurfacingROIEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SURFACING_ROI_ENABLED,
    );
  }

  /**
   * Auto Decline Transaction - M1 - Fuel Level Above X
   * @returns boolean
   * @memberof FleetCardsFeatureFlagService
   * @description This will also be used for Auto Decline Transaction - M3 - Temporary Card Overrides
   */
  public isFleetCardsAutoDeclineTransactionM1FuelLevelAboveXEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_AUTO_DECLINE_TRANSACTION_M1_FUEL_LEVEL_ABOVE_X_ENABLED,
    );
  }

  /**
   * Auto Decline Transaction - M2 - Permanent Card Overrides
   * @returns boolean
   * @memberof FleetCardsFeatureFlagService
   */
  public isFleetCardsAutoDeclineTransactionM2PermanentCardOverridesEnabled(): boolean {
    return this.statsigService.evaluateGate(
      FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_AUTO_DECLINE_TRANSACTION_M2_PERMANENT_CARD_OVERRIDES_ENABLED,
    );
  }

  public isFleetCardsTemporaryOverridesForSpendAndSecurityControlsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.
      FLEET_CARDS_TEMPORARY_OVERRIDES_FOR_SPEND_AND_SECURITY_CONTROLS);
  }

  public isFleetCardsPaymentWidgetChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_PAYMENT_WIDGET_CHANGES_ENABLED);
  }

  public isFleetCardsVlmSurfaceLastKnownLocationEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_VLM_SURFACE_LAST_KNOWN_LOCATION_ENABLED);
  }

  public isFleetCardsOverviewChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_OVERVIEW_CHANGES_ENABLED);
  }

  public isFleetCardsApplicationExpressOptionEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_APPLICATION_EXPRESS_OPTION_ENABLED);
  }

  public isFleetCardsMissedSavingsRefinementChangesEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MISSED_SAVINGS_REFINEMENT_CHANGES);
  }

  public isFleetCardsMissingL3DataSuggestionEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MISSING_L3_DATA_SUGGESTION);
  }

  public isFleetCardsNudgeExperimentsPhase2Enabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_NUDGE_UPSELLS_PHASE2_ENABLED);
  }

  public isFleetCardsAutoDeclineEnhancementFlagEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_AUTO_DECLINE_ENHANCEMENT_FLAG_ENABLED);
  }

  public isFleetCardsIncludeTransactionFleetViewZoomEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_INCLUDE_TRANSACTION_FLEET_VIEW_ZOOM_ENABLED);
  }

  public isFleetCardsDefAndReeferFuelRecategorizationEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_DEF_AND_REEFER_FUEL_RECATEGORIZATION_ENABLED);
  }

  public isFleetCardsBonusRebatesEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BONUS_REBATES_ENABLED);
  }

  public isFleetCardsBonusRebatesOverviewSidebarEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BONUS_REBATES_OVERVIEW_SIDEBAR_ENABLED);
  }

  public isFleetCardsDeprecateFleetViewPopoverEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_DEPRECATE_FLEET_VIEW_POPOVER);
  }

  public isFleetCardsBenefitsEstimatedSavingsBannerEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BENEFITS_ESTIMATED_SAVINGS_BANNER_ENABLED);
  }

  public isFleetCardsCardInfoV2ApiEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CARD_INFO_V2_API_ENABLED);
  }

  public isFleetCardsGirIntegrationFeEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_GIR_INTEGRATION_FE_ENABLED);
  }

  public isFleetCardsRelayPaymentIntegrationFeEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_RELAY_PAYMENT_INTEGRATION_FE_ENABLED);
  }

  public isFleetCardsTosEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_TOS_ENABLED);
  }

  public isFleetCardsEnableMoreTransactionCustomFieldsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ENABLE_MORE_TRANSACTION_CUSTOM_FIELDS_ENABLED);
  }

  public isFleetCardsPromoOffersEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_PROMO_OFFERS_ENABLED);
  }

  public isFleetCardsBulkFuelAtBoosterEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_BULK_FUEL_AT_BOOSTER_ENABLED);
  }

  public isFleetCardsShowTooltipForMcleodEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SHOW_TOOLTIP_FOR_MCLEOD_ENABLED);
  }

  public isFleetCardsFleetUserCardsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FLEET_USER_CARDS_ENABLED);
  }

  public isFleetCardsOverrideSupportEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_OVERRIDE_SUPPORT_ENABLED);
  }

  public isFleetCardsCaptureAssetInfoOnTransactionsEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_CAPTURE_ASSET_INFO_ON_TRANSACTIONS);
  }

  public isFleetCardsEditCategoryEnhancementEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_EDIT_CATEGORY_ENHANCEMENT_ENABLED);
  }

  public isFleetCardsNewCardActivationFlowEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_NEW_CARD_ACTIVATION_FLOW_ENABLED);
  }

  public isFleetCardsTransactionDetailsDrawerV3Enabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_TRANSACTION_DETAILS_DRAWER_V3_ENABLED);
  }

  public isFleetCardsNoFraudGuaranteeInsightsAndBranding(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_NO_FRAUD_GUARANTEE_INSIGHTS_AND_BRANDING);
  }

  public isFleetCardsSoftDeclineVslmAndFuelEnabled (): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SOFT_DECLINE_VSLM_AND_FUEL_ENABLED);
  }

  public isFleetCardsSaasFeePublicAppEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SAAS_FEE_PUBLIC_APP_ENABLED);
  }

  public isFleetCardsSpendSummaryReportsUpdatesEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SPEND_SUMMARY_REPORT_UPDATES_ENABLED);
  }
  
  public isFleetCardsMotiveCardPhaseOneEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_MOTIVE_CARD_POLICY_PHASE_ONE_ENABLED);
  }

  public isFleetCardsCardDeliveryAddressInCardApplicationEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.CARD_APPLICATION_CARD_DELIVERY_ADDRESS_ENABLED);
  }

  public isFleetCardsSavingsCalculatorFeEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_SAVINGS_CALCULATOR_FE_ENABLED);
  }

  public isFleetCardsFederalFuelTaxEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_FEDERAL_FUEL_TAX_ENABLED);
  }

  public isFleetCardsAdditionalCategoriesFeEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARDS_ADDITIONAL_TRANSACTION_CATEGOEIES_FE_ENABLED);
  }

  public isFleetCardBenefitsCtaRefactorEnabled(): boolean {
    return this.statsigService.evaluateGate(FLEET_CARDS_FEATURE_FLAGS.FLEET_CARD_BENEFITS_CTA_REFACTOR);
  }

  // Statsig Experiments

  public getFleetCardsBenefitsPageExperimentValue(): boolean {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_AB_TEST_ON_BENEFITS_PAGE)
      .get('enable_feature', false);
  }

  public getFleetCardsRemoving5CentsOffExperimentValue(): string {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_AB_TEST_ON_REMOVING_5_CENTS_OFF)
      .get('value', '5_cents_off');
  }

  public getFleetCardsContextualUpsellFuelOverviewPageValue(): string {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_AB_TEST_ON_CONTEXTUAL_UPSELL_FUEL_OVERVIEW_PAGE)
      .get('value', 'no_banner');
  }

  public getFleetCardsContextualUpsellFuelPurchasePageValue(): string {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_AB_TEST_ON_CONTEXTUAL_UPSELL_FUEL_PURCHASE_PAGE)
      .get('value', 'no_banner');
  }

  public getFleetCardsContextualUpsellFuelReceiptUploadPageValue(): boolean {
    return this.statsigService
      .getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_AB_TEST_ON_CONTEXTUAL_UPSELL_FUEL_RECEIPT_UPLOAD_PAGE)
      .get('value', false);
  }

  public getFleetCardsActivationLandingPageValue(): string {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_ACTIVATION_LANDING_PAGE)
      .get('value', 'no_change');
  }

  public getFleetCardsShowFuelPurchaseDataInCardApplicationExperimentValue(): boolean {
    return this.statsigService
      .getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_SHOW_FUEL_PURCHASE_DATA_IN_CARD_APPLICATION)
      .get('value', false);
  }

  public getFleetCardsApplicationNudgeExperimentValue(): string {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_APPLICATION_NUDGE)
      .get('value', '');
  }

  public getFleetCardsExpansionUpsellsStickyBannerVariant(): number {
    return this.statsigService.getExperiment(FLEET_CARDS_EXPERIMENTS.FLEET_CARDS_EXPANSIONS_UPSELLS_STICKY_BANNER)
      .get('value', 0);
  }
}
